import { Card, Modal } from 'react-bootstrap';
import styled from 'styled-components';

export const PageWrap = styled.div`
  font-family: 'SourceSansPro';
  font-size: 16px;
  color: ${({ theme }) => theme.primaryLight3};
  padding: 12px 32px 32px;
  font-weight: 400;
  .form-check-input:checked {
    background-color: ${({ theme }) => theme.mainPrimary};
    border-color: ${({ theme }) => theme.mainPrimary};
  }
  .form-check-input:focus {
    box-shadow: none;
  }
  .col-xxl-3 {
    @media screen and (min-width: 1400px) {
      width: 25%;
      flex: 0 0 auto;
    }
  }
`;

export const PageTitle = styled.h5`
  font-size: 18px;
  color: ${({ theme }) => theme.secondaryLight};
  font-weight: 500;
`;

export const ItemMain = styled.div`
  padding: 24px;
  border-radius: 8px;
  background-color: ${({ theme }) => theme.white};
  border: 1px solid ${({ theme }) => theme.lightGray1};
`;

export const ItemsTable = styled(Card)`
  border: 0;
  overflow: auto;
  @media screen and (max-width: 1441px) {
    max-width: 657px;
  }
  &.activity-table {
    max-height: 450px;
    max-width: 100%;
  }
  table {
    thead {
      tr {
        th {
          padding: 15px;
          border-bottom: 1px solid ${({ theme }) => theme.lightGray1};
          font-size: 16px;
          font-weight: 500;
          color: ${({ theme }) => theme.secondaryLight};
          vertical-align: middle;
          white-space: nowrap;
          &:not(:nth-child(2)) {
            text-align: center;
          }
        }
      }
    }
    tbody {
      tr {
        td {
          padding: 15px;
          font-size: 14px;
          font-weight: 500;
          border: 0;
          white-space: nowrap;
          color: ${({ theme }) => theme.secondaryLight};
          background-color: #fff;
          vertical-align: middle;
          > svg {
            margin-right: 20px;
            color: ${({ theme }) => theme.mainPrimary};
          }
          .badge {
            font-size: 14px;
            font-weight: normal;
            border-radius: 30px;
            padding: 10px 15px;
            &.badge-active {
              color: ${({ theme }) => theme.success};
              background-color: ${({ theme }) => theme.success3};
            }
            &.badge-inactive {
              color: ${({ theme }) => theme.danger2};
              background-color: ${({ theme }) => theme.danger3};
            }
          }
          &:not(:nth-child(2)) {
            text-align: center;
          }
          &:nth-child(3) {
            font-size: 16px;
            font-weight: 600;
          }
          &:nth-child(4) {
            div {
              justify-content: center;
            }
          }
        }
      }
    }
  }
`;

export const QuantitySelector = styled.div`
  display: flex;
  align-items: center;
  gap: 16px;
  button {
    height: 32px;
    width: 32px;
    border-radius: 10px;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 26px;
    padding: 0;
    font-weight: 100;
    :first-child {
      background-color: ${({ theme }) => theme.bodyBg};
      color: ${({ theme }) => theme.primaryDark};
      border-color: ${({ theme }) => theme.bodyBg};
      &:hover,
      &:focus,
      &:active {
        color: ${({ theme }) => theme.primaryDark} !important;
        background-color: ${({ theme }) => theme.bodyBg} !important;
        border-color: ${({ theme }) => theme.bodyBg} !important;
      }
    }
    svg {
      width: 12px;
    }
  }
`;

export const OrderSummary = styled.div`
  background-color: ${({ theme }) => theme.primary}1a;
  border-radius: 8px;
  padding: 24px;
  position: sticky;
  top: 100px;
  margin-left: auto;
  @media screen and (max-width: 1441px) {
    max-width: 364px;
  }
  h5 {
    color: ${({ theme }) => theme.primaryDark};
    font-size: 16px;
    font-weight: 500;
    border-bottom: 1px solid ${({ theme }) => theme.primary}1a;
    padding-bottom: 15px;
  }
`;

export const OrderSummaryList = styled.ul`
  padding-left: 0;
  li {
    list-style: none;
    color: ${({ theme }) => theme.primaryDark};
    display: flex;
    justify-content: space-between;
    padding: 7px 0;
    h4 {
      font-weight: 500;
      margin-bottom: 0;
      font-size: 16px;
    }
    &:last-child {
      border-top: 1px solid ${({ theme }) => theme.primary}1a;
      margin-top: 9px;
      padding-top: 9px;
    }
  }
`;

export const CartTableHeading = styled.div`
  display: flex;
  justify-content: space-between;
  margin-top: 20px;
  margin-bottom: 20px;
  @media screen and (max-width: 1441px) {
    max-width: 657px;
  }
  h3 {
    font-weight: 500;
  }
  h5 {
    font-weight: 500;
  }
`;
export const ProductDetail = styled.div`
  display: flex;
  align-items: center;
`;
export const ProductImg = styled.div`
  margin-right: 20px;
  img {
    height: 92px;
    width: 92px;
    object-fit: cover;
    border-radius: 4px;
  }
`;
export const ProductInfo = styled.div`
  h4 {
    font-weight: 500;
    margin-bottom: 5px;
    color: ${({ theme }) => theme.primaryDark};
  }
  span {
    color: ${({ theme }) => theme.primaryDark};
    font-size: 12px;
    &:nth-child(3) {
      padding: 4px 12px;
    }
  }
`;
export const Quantity = styled.span`
  min-width: 15px;
  text-align: center;
`;
export const StepWrap = styled.div`
  max-width: 500px;
  margin: 0 auto;
`;
export const Steps = styled.ul`
  display: flex;
  padding: 0;
  counter-reset: number;
  position: relative;
  justify-content: space-between;
  &:before {
    content: '';
    position: absolute;
    left: 30px;
    right: 10px;
    top: 15px;
    height: 1px;
    background-color: ${({ theme }) => theme.primaryDark};
  }
  li {
    color: ${({ theme }) => theme.primaryDark};
    font-size: 18px;
    position: relative;
    list-style: none;
    background-color: ${({ theme }) => theme.white};
    &:not(:first-child) {
      padding-left: 10px;
    }
    &:before {
      counter-increment: number;
      content: counter(number);
      background-color: ${({ theme }) => theme.primaryDark};
      color: ${({ theme }) => theme.white};
      width: 20px;
      height: 20px;
      text-align: center;
      line-height: 20px;
      border-radius: 100%;
      display: inline-block;
      font-size: 14px;
    }
    &.active {
      color: ${({ theme }) => theme.primary};
      &:before {
        background-color: ${({ theme }) => theme.primary};
      }
    }
    span {
      position: relative;
      z-index: 1;
      padding: 0 5px;
    }
  }
`;
export const PaymentInfo = styled.div`
  h5 {
    font-size: 18px;
    margin-bottom: 5px;
    font-weight: 500;
    line-height: 23px;
  }
  p {
    color: ${({ theme }) => theme.primaryDark};
    font-weight: normal;
    font-size: 14px;
  }
`;
export const PaymentOption = styled.ul`
  padding: 0px;
  margin-top: 10px;
  li {
    list-style: none;
    color: ${({ theme }) => theme.primaryDark};
    display: flex;
    border-bottom: 1px solid ${({ theme }) => theme.borderColorLight};
    padding: 15px 0;
    &:last-child {
      border-bottom: 0;
    }
    > span {
      margin-left: auto;
      svg {
        margin-left: 10px;
        cursor: pointer;
        &:hover {
          color: ${({ theme }) => theme.primary};
        }
      }
    }
  }
`;

export const PaymentModal = styled(Modal)`
  .modal-dialog {
    max-width: 320px;
    margin: 0 auto;
    .modal-content {
      border: 0;
      padding: 20px 17px;
      .close-icon {
        display: block;
        margin-left: auto;
        path {
          stroke: ${({ theme }) => theme.primaryDark};
        }
      }
      p {
        color: ${({ theme }) => theme.primaryDark};
        font-size: 16px;
        font-weight: normal;
        margin-bottom: 20px;
      }
    }
  }
`;
export const PaymentModalInfo = styled.div`
  svg {
    color: ${({ theme }) => theme.primary};
  }
  h4 {
    font-size: 22px;
    padding: 0 10px;
    color: ${({ theme }) => theme.primaryDark};
    font-weight: 500;
  }
`;
export const Reason = styled.h5`
  color: ${({ theme }) => theme.primary};
  font-weight: 500;
  margin-bottom: 10px;
`;

export const CartStyled = {
  PageWrap,
  PageTitle,
  ItemMain,
  ItemsTable,
  QuantitySelector,
  OrderSummary,
  OrderSummaryList,
  CartTableHeading,
  ProductDetail,
  ProductImg,
  ProductInfo,
  Quantity,
  StepWrap,
  Steps,
  PaymentInfo,
  PaymentOption,
  PaymentModal,
  PaymentModalInfo,
  Reason,
};
